import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QrislyComponent } from './qrisly.component';

const routes: Routes = [
  { path: '', component: QrislyComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QrislyRoutingModule { }
